import {Icon} from "@/components/icon/Icon.tsx";
import {IconProps} from "@/components/icon/Icon.types.ts";
import classnames from "classnames";
import {ReactNode} from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {Placement} from "react-bootstrap/types";
import {IconType} from "react-icons";
import {FiInfo} from "react-icons/fi";

interface TooltipIconProps {
  title: string | ReactNode;
  className?: string;
  placement?: Placement;
  icon?: IconType;
  iconProps?: Omit<IconProps, "icon">;
}

export const TooltipIconRA = ({title, placement, className, icon, iconProps}: TooltipIconProps) => {
  return (
    <OverlayTrigger placement={placement || "top"} overlay={(props) => <Tooltip {...props}>{title}</Tooltip>}>
      <Icon
        className={classnames(className, {
          "cursor-help": !className || !className.includes("cursor-"),
        })}
        icon={icon || FiInfo}
        {...iconProps}
      />
    </OverlayTrigger>
  );
};
